import React from 'react'
import { RadioButtons, RadioButtonsProps } from '../../radioButtons'

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>

interface TimelinePeriodSelectorProps extends Optional<RadioButtonsProps, 'propertyToBeReturned' | 'options'> {}

const defaultOptions = [
  { label: 'Ano', value: 'years' },
  { label: 'Mês', value: 'months' },
  { label: 'Dia', value: 'days' }
]

export const TimelinePeriodSelector = ({
  options,
  value,
  isDisabled,
  propertyToBeReturned,
  onChange
}: TimelinePeriodSelectorProps): JSX.Element => {
  const radioOptions = options ?? defaultOptions
  return (
    <RadioButtons
      options={radioOptions}
      value={value}
      isDisabled={isDisabled}
      propertyToBeReturned={propertyToBeReturned ?? 'value'}
      onChange={onChange}
    />
  )
}
